import { render, staticRenderFns } from "./courseListNew.vue?vue&type=template&id=37726bb2"
import script from "./courseListNew.vue?vue&type=script&lang=js"
export * from "./courseListNew.vue?vue&type=script&lang=js"
import style0 from "./courseListNew.vue?vue&type=style&index=0&id=37726bb2&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data/jenkins/data/workspace/KCC_AUDIT_PROD_Frontend/node_modules/vue-loader/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('37726bb2')) {
      api.createRecord('37726bb2', component.options)
    } else {
      api.reload('37726bb2', component.options)
    }
    module.hot.accept("./courseListNew.vue?vue&type=template&id=37726bb2", function () {
      api.rerender('37726bb2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/client-view/keeCourses/courseListNew.vue"
export default component.exports